module.exports = __webpack_public_path__ + "img/yztx.a2038bac.png";